export const TEST_ID = 'labelPrimaryText';
